module.exports = __webpack_public_path__ + "assets/img/machine_icon_back.a751be08.png";